/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Developer_Edit_Scope_RemovedInputs */



/**
* | output |
* | --- |
* | "Removing a scope withdraws it from every member who granted it and revokes their tokens carrying it." |
*
* @param {Developer_Edit_Scope_RemovedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const developer_edit_scope_removed = /** @type {((inputs?: Developer_Edit_Scope_RemovedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Developer_Edit_Scope_RemovedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retirer une permission la retire à chaque membre qui l'a accordée et révoque leurs jetons qui la portent.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Quitar un permiso lo retira de cada miembro que lo concedió y revoca sus tokens que lo llevan.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Remover uma permissão a retira de cada membro que a concedeu e revoga os tokens deles que a carregam.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovere un permesso lo ritira da ogni membro che lo ha concesso e revoca i loro token che lo contengono.")
	return /** @type {LocalizedString} */ ("Removing a scope withdraws it from every member who granted it and revokes their tokens carrying it.")
});